import { c as _c } from "react/compiler-runtime";
import { useDebugLogs } from '../hooks/use-debug-logs';
import { Button } from '@/components/ui/button'; // Assuming Button component is available
import { useAuthStore } from '@/features/auth/store/auth-store';
import { useSession } from 'next-auth/react';
export function DebugPanel() {
  const $ = _c(58);
  const {
    paginatedLogs,
    createdAt,
    lastMessageAt,
    reset,
    currentPage,
    totalPages,
    setPage,
    isPaused,
    togglePause,
    allLogs
  } = useDebugLogs();
  const {
    isAuthenticated
  } = useAuthStore();
  const {
    data: session
  } = useSession();
  let t0;
  if ($[0] !== session?.expires) {
    t0 = new Date(session?.expires || 0).toLocaleString();
    $[0] = session?.expires;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sessionValidUntil = t0;
  let t1;
  if ($[2] !== allLogs || $[3] !== createdAt || $[4] !== isPaused || $[5] !== lastMessageAt || $[6] !== togglePause) {
    t1 = () => {
      if (!isPaused) {
        togglePause();
      }
      let logContent = "==================================\n";
      logContent = logContent + "SigmaVue Debug Log | WebSockets\n";
      logContent;
      logContent = logContent + `Session Start: ${new Date(createdAt).toLocaleString()}\n`;
      logContent;
      logContent = logContent + `Last Message Received: ${lastMessageAt ? new Date(lastMessageAt).toLocaleString() : "N/A"}\n\n`;
      logContent;
      allLogs.forEach(log => {
        logContent = logContent + `[${new Date(log.timestamp).toLocaleString()}] ${log.level.toUpperCase()} ${log.message}`;
        logContent;
        if (log.context) {
          logContent = logContent + ` - ${JSON.stringify(log.context)}`;
          logContent;
        }
        logContent = logContent + "\n";
        logContent;
      });
      logContent = logContent + "\nEnd of log file\n";
      logContent;
      logContent = logContent + "==================================\n";
      logContent;
      const blob = new Blob([logContent], {
        type: "text/plain;charset=utf-8"
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `SigmaVue_DebugLog_${new Date().toISOString().split("T")[0]}.txt`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
    $[2] = allLogs;
    $[3] = createdAt;
    $[4] = isPaused;
    $[5] = lastMessageAt;
    $[6] = togglePause;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleExport = t1;
  let t2;
  if ($[8] !== currentPage || $[9] !== setPage || $[10] !== totalPages) {
    t2 = totalPages > 1 && <div className="flex justify-between items-center py-2 border-b border-muted"><Button size="sm" variant="outline" onClick={() => setPage(currentPage - 1)} disabled={currentPage <= 1}>Previous</Button><span className="text-xs text-muted-foreground">Page {currentPage} of {totalPages}</span><Button size="sm" variant="outline" onClick={() => setPage(currentPage + 1)} disabled={currentPage >= totalPages}>Next</Button></div>;
    $[8] = currentPage;
    $[9] = setPage;
    $[10] = totalPages;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const paginationControls = t2;
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <strong>Session Start:</strong>;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== createdAt) {
    t4 = new Date(createdAt).toLocaleString();
    $[13] = createdAt;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <p>{t3} {t4}</p>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <strong>Last Message:</strong>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== lastMessageAt) {
    t7 = lastMessageAt ? new Date(lastMessageAt).toLocaleString() : "N/A";
    $[18] = lastMessageAt;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <p>{t6} {t7}</p>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <strong>Session Valid Until:</strong>;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = sessionValidUntil ? sessionValidUntil : "N/A";
  let t11;
  if ($[23] !== t10) {
    t11 = <p>{t9} {t10}</p>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <strong>Is Authenticated:</strong>;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = isAuthenticated ? "Yes" : "No";
  let t14;
  if ($[26] !== t13) {
    t14 = <p>{t12} {t13}</p>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14 || $[30] !== t5 || $[31] !== t8) {
    t15 = <div className="mb-4">{t5}{t8}{t11}{t14}</div>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t5;
    $[31] = t8;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <h2 className="font-semibold">Logs</h2>;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== handleExport) {
    t17 = <button type="button" onClick={handleExport} className="text-xs text-blue-500 hover:text-blue-700">Export</button>;
    $[34] = handleExport;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = `text-xs ${isPaused ? "text-green-500 hover:text-green-700" : "text-yellow-500 hover:text-yellow-700"}`;
  const t19 = isPaused ? "Resume" : "Pause";
  let t20;
  if ($[36] !== t18 || $[37] !== t19 || $[38] !== togglePause) {
    t20 = <button type="button" onClick={togglePause} className={t18}>{t19}</button>;
    $[36] = t18;
    $[37] = t19;
    $[38] = togglePause;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== reset) {
    t21 = <button type="button" onClick={reset} className="text-xs text-red-500 hover:text-red-700">Clear</button>;
    $[40] = reset;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t17 || $[43] !== t20 || $[44] !== t21) {
    t22 = <div className="mb-2 flex justify-between items-center">{t16}<div className="flex items-center gap-2">{t17}{t20}{t21}</div></div>;
    $[42] = t17;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== paginatedLogs.length) {
    t23 = paginatedLogs.length === 0 && <p className="text-muted-foreground text-center">No logs to display.</p>;
    $[46] = paginatedLogs.length;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== paginatedLogs) {
    t24 = paginatedLogs.map(_temp);
    $[48] = paginatedLogs;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t23 || $[51] !== t24) {
    t25 = <div className="flex-grow h-64 overflow-auto bg-muted rounded-md p-2 my-2">{t23}{t24}</div>;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== paginationControls || $[54] !== t15 || $[55] !== t22 || $[56] !== t25) {
    t26 = <div className="p-4 text-sm flex flex-col h-full" data-sentry-component="DebugPanel" data-sentry-source-file="DebugPanel.tsx">{t15}{t22}{paginationControls}{t25}{paginationControls}</div>;
    $[53] = paginationControls;
    $[54] = t15;
    $[55] = t22;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  return t26;
}
function _temp(log_0) {
  return <div key={`${log_0.timestamp}-${log_0.level}-${log_0.message}`} className="mb-1 font-mono text-xs"><span className="text-muted-foreground">[{new Date(log_0.timestamp).toLocaleTimeString()}]</span>{" "}<span className={log_0.level === "error" ? "text-red-500" : log_0.level === "warning" ? "text-yellow-500" : "text-muted-foreground"}>{log_0.level.toUpperCase()}</span>{" "}<span>{log_0.message}</span>{log_0.context && <pre className="mt-1 p-1 bg-muted text-muted-foreground rounded text-[10px] overflow-auto">{JSON.stringify(log_0.context, null, 2)}</pre>}</div>;
}